// extracted by mini-css-extract-plugin
export var scoreSetupContainer = "ScoreSetup-module--scoreSetupContainer--I-1PQ";
export var scoreSetupTitle = "ScoreSetup-module--scoreSetupTitle--3puNn";
export var scoreTargetInput = "ScoreSetup-module--scoreTargetInput--T3lmN";
export var scoreTargetSetupSubmitButton = "ScoreSetup-module--scoreTargetSetupSubmitButton--RJzTJ";
export var backButton = "ScoreSetup-module--backButton--o4Q6f";